import { render, staticRenderFns } from "./ed-edit-course-class.component.vue?vue&type=template&id=1e0ccece&scoped=true&"
import script from "./ed-edit-course-class.component.ts?vue&type=script&lang=ts&"
export * from "./ed-edit-course-class.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-edit-course-class.component.scss?vue&type=style&index=0&id=1e0ccece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0ccece",
  null
  
)

export default component.exports